module.exports = __webpack_public_path__ + "img/onboadring-icon-wallet.d09b9631.svg";